import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import "./Contact.css";

const Contact = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("");

  // 🔥 Auto dismiss message after 3 sec
  useEffect(() => {
    if (status) {
      const timer = setTimeout(() => {
        setStatus("");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [status]);

  // 🔥 Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      const regex = /^[A-Za-z\s]*$/;
      if (!regex.test(value)) return;
    }

    setFormData({
      ...formData,
      [name]: value
    });
  };

  // 🔥 Validation
  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Enter valid email";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    return newErrors;
  };

  // 🔥 Submit with EmailJS
  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {

      emailjs.send(
        "service_mysl40f",
        "template_n5jy1wo",
        {
          name: formData.name,
          email: formData.email,
          message: formData.message,
        },
        "N1CvNyWIsnKIqXO2D"
      )
      .then(() => {
        setStatus("success");

        setFormData({
          name: "",
          email: "",
          message: ""
        });
      })
      .catch(() => {
        setStatus("error");
      });
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-card">

        {/* LEFT */}
        <div className="contact-info">
          <h2>Contact Us</h2>
          <p className="subtitle">We’d love to hear from you 💛</p>

          <div className="info-block">
            <span>📞</span>
            <p><strong>Phone:</strong> +91 95038 73735</p>
          </div>

          <div className="info-block">
            <span>📧</span>
            <p>
              <strong>Email:</strong>{" "}
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=handmadebags.pune@gmail.com"
                target="_blank"
                rel="noreferrer"
                className="email-link"
              >
                handmadebags.pune@gmail.com
              </a>
            </p>
          </div>

          <div className="info-block">
            <span>📍</span>
            <p><strong>Address:</strong> Pune, Maharashtra</p>
          </div>

          <div className="info-block">
            <span>⏰</span>
            <p><strong>Hours:</strong> Open 24 hours</p>
          </div>
        </div>

        {/* RIGHT */}
        <div className="contact-form">
          <h2>Send Message</h2>

          <form onSubmit={handleSubmit}>

            {/* NAME */}
            <div className="input-group">
              <input
                type="text"
                name="name"
                placeholder=" "
                value={formData.name}
                onChange={handleChange}
              />
              <label>Name</label>
              {errors.name && <span className="error">{errors.name}</span>}
            </div>

            {/* EMAIL */}
            <div className="input-group">
              <input
                type="email"
                name="email"
                placeholder=" "
                value={formData.email}
                onChange={handleChange}
              />
              <label>Email</label>
              {errors.email && <span className="error">{errors.email}</span>}
            </div>

            {/* MESSAGE */}
            <div className="input-group">
              <textarea
                name="message"
                placeholder=" "
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              <label>Message</label>
              {errors.message && <span className="error">{errors.message}</span>}
            </div>

            <button type="submit">Send Message</button>

            {/* STATUS MESSAGE */}
            {status === "success" && (
              <p style={{ color: "green", marginTop: "10px", textAlign: "center" }}>
                Message sent successfully ✅
              </p>
            )}

            {status === "error" && (
              <p style={{ color: "red", marginTop: "10px", textAlign: "center" }}>
                Failed to send message ❌
              </p>
            )}

          </form>
        </div>

      </div>
    </div>
  );
};

export default Contact;